import { type BaseBoxProps, Box, type BoxProps } from '../Box'
import {
  baseTextCss,
  textLCss,
  textMCss,
  textSCss,
  textXsCss,
  textXxsCss,
} from './Text.css'

export type PlaceHolderTextProps = Omit<BoxProps, 'fontSize' | 'size'> & {
  size?: Exclude<BaseBoxProps['fontSize'], 'xxs'>
}

export function PlaceholderText({ size, ...props }: PlaceHolderTextProps) {
  return (
    <Box
      {...props}
      className={[
        baseTextCss,
        {
          [textXxsCss]: size === '10',
          [textXsCss]: size === 'xs' || size === '12',
          [textSCss]: size === 's' || size === '14',
          [textMCss]: size === 'm' || size === '16',
          [textLCss]: size === '24',
        },
      ]}
      style={{ ...props.style, background: '#3c3c3c' }}
      borderRadius="curved"
    />
  )
}
